/* 
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetPaymentTransactionQidList = () => {
  const [transactionQidList, setTransactionQidList] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const { token } = useAuthContext();

  const { get } = useAbortController();

  const getServPaymentTransactionList = useCallback(async () => {
    if (!token) {
      return;
    }
    setLoading(true);
    const url = process.env.REACT_APP_QID_PAYMENT_TR_TYPE_LIST;

    const controller = get();
    const config = { signal: controller.signal };

    const headers = {
      'Session-Token': token,
      'Content-Type': 'application/json',
    };

    try {
      let response = await axiosCall({ url: url, method: 'get' }, config, headers);
      setErrorMessage('');
      setTransactionQidList(response);
      setLoading(false);
    } catch (error) {
      if (error.code !== 'ERR_CANCELED') {
        setErrorMessage('Error Loading Payment Transaction QID List.');
        setLoading(false);
        console.error(error.message);
      }
    }
  }, [get, token]);

  useEffect(() => {
    getServPaymentTransactionList();
  }, [getServPaymentTransactionList]);

  return {
    transactionQidList: transactionQidList,
    transactionQidErrorMessages: errorMessage,
    loadingTransactionQid: loading,
  };
};

export default useGetPaymentTransactionQidList;
